<div class="input-group input-group-merge">
  <input
    [type]="inputType"
    class="form-control"
    [formControl]="filterFormControl"
    [placeholder]="placeholder" />
  @if (!filterFormControl.value) {
    <div class="input-group-append">
      <span class="input-group-text"><span data-feather="filter"></span></span>
    </div>
  }
  @if (filterFormControl.value) {
    <div
      class="input-group-append cursor-pointer"
      (click)="clearFilter()">
      <span class="input-group-text text-danger"><span data-feather="x"></span></span>
    </div>
  }
</div>
